<template>
    <div id="jitsi-wrapper">
        <header
            class="d-flex align-items-center justify-content-between py-2 px-3 text-black font-size-md header-custom-border jitsi-header position-relative"
        >
            <div class="d-flex align-items-center">
                <div class="img-div">
                    <img class="axxess-key-logo" src="../../../img/Axxess_Logo-01.svg" />
                </div>
                <span class="ms-3 small"> {{ timer }}</span>
            </div>
            <span v-if="roomName" class="room-name-div">{{ roomName }}</span>
            <span v-else-if="roomInfo.roomName" class="room-name-div">{{ sliceRoomId(roomInfo.roomName) }}</span>
            <i class="text-danger bg-white jitsi-cancel-btn fas fa-times-circle" @click="cancel()"></i>
        </header>
        <div class="jitsi-video jitsi-container">
            <JitsiMeeting
                v-if="!loading && roomInfo"
                :domain="domain"
                :roomName="roomInfo.roomName"
                :jwt="jwt"
                fileRecordingsEnabled="false"
                :options="jitsiOptions"
                :configOverwrite="configOverwrite"
                :interfaceConfigOverwrite="jitsiOptions.interfaceConfigOverwrite"
                @onJitsiMeetJSLoaded="handleJitsiMeetJSLoaded"
                @onConferenceJoined="handleConferenceJoined"
                @on-ready-to-close="handleConferenceLeft"
                @on-api-ready="handleApiReady"
                @onError="handleError"
                :width="meetingWidth"
                height="500px"
            >
            </JitsiMeeting>
            <div v-if="participantsPaneOpen && invitedParticipants.length > 0">
                <div
                    class="invited-participants-list"
                    :class="[{ shrunk: !otherParticipantsOpen, list: otherParticipantsOpen }]"
                    @click="!otherParticipantsOpen ? toggleOtherParticipants : null"
                >
                    <div class="invited-users-header">
                        <p v-if="otherParticipantsOpen" class="ms-n3">
                            <span class="invited-participants-header"
                                >Other Participants ({{ invitedParticipants.length }})</span
                            >
                        </p>
                        <i
                            title="toggle other participants view"
                            class="fas jtitsi-toggle-icon"
                            @click="toggleOtherParticipants"
                            :class="[otherParticipantsOpen ? 'fa-eye-slash ' : 'fa-users']"
                        ></i>
                    </div>

                    <ul class="ms-n3" v-if="otherParticipantsOpen">
                        <li
                            class="invited-participant-item"
                            v-for="invitedParticipant in invitedParticipants"
                            :key="invitedParticipant.id"
                        >
                            {{ invitedParticipant.displayName }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./JitsiPage"></script>
<style src="./JitsiPage.scss"></style>
